module.exports = __webpack_public_path__ + "static/img/meteo2.afb6756.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/meteo2.png
// module id = bClL
// module chunks = 0